import { useTranslation } from 'react-i18next';
import * as newsRaw from '../mocks/newsData';
import * as baggageRaw from '../mocks/baggageData';
import * as contactRaw from '../mocks/contactData';
import * as bookingFlowRaw from '../mocks/bookingFlowData';
import * as cancelPolicyRaw from '../mocks/cancelPolicyData';
import * as accessRaw from '../mocks/accessData';
import * as flowRaw from '../mocks/flowData';
import * as reviewsRaw from '../mocks/reviewsData';
import * as faqRaw from '../mocks/faqData';
import * as firstTimeRaw from '../mocks/firstTimeData';
import * as pricingRaw from '../mocks/pricingData';
import * as privacyRaw from '../mocks/privacyData';
import * as tokushohoRaw from '../mocks/tokushohoData';
import * as companyRaw from '../mocks/companyData';
import * as homeRaw from '../mocks/homeData';
import * as giftRaw from '../mocks/giftData';
import * as yokohamaRaw from '../mocks/yokohamaData';
import * as columnRaw from '../mocks/columnData';

type Lang = 'ja' | 'en';

function useLang(): Lang {
  const { i18n } = useTranslation();
  return i18n.language === 'en' ? 'en' : 'ja';
}

export const useNewsData = () => {
  const l = useLang();
  return l === 'en' ? newsRaw.en : newsRaw.ja;
};

export const useBaggageData = () => {
  const l = useLang();
  return l === 'en' ? baggageRaw.en : baggageRaw.ja;
};

export const useContactData = () => {
  const l = useLang();
  return l === 'en' ? contactRaw.en : contactRaw.ja;
};

export const useBookingFlowData = () => {
  const l = useLang();
  return l === 'en' ? bookingFlowRaw.en : bookingFlowRaw.ja;
};

export const useCancelPolicyData = () => {
  const l = useLang();
  return l === 'en' ? cancelPolicyRaw.en : cancelPolicyRaw.ja;
};

export const useAccessData = () => {
  const l = useLang();
  return l === 'en' ? accessRaw.en : accessRaw.ja;
};

export const useFlowData = () => {
  const l = useLang();
  return l === 'en' ? flowRaw.en : flowRaw.ja;
};

export const useReviewsData = () => {
  const l = useLang();
  return l === 'en' ? reviewsRaw.en : reviewsRaw.ja;
};

export const useFaqData = () => {
  const l = useLang();
  return l === 'en' ? faqRaw.en : faqRaw.ja;
};

export const useFirstTimeData = () => {
  const l = useLang();
  return l === 'en' ? firstTimeRaw.en : firstTimeRaw.ja;
};

export const usePricingData = () => {
  const l = useLang();
  return l === 'en' ? pricingRaw.en : pricingRaw.ja;
};

export const usePrivacyData = () => {
  const l = useLang();
  return l === 'en' ? privacyRaw.en : privacyRaw.ja;
};

export const useTokushohoData = () => {
  const l = useLang();
  return l === 'en' ? tokushohoRaw.en : tokushohoRaw.ja;
};

export const useCompanyData = () => {
  const l = useLang();
  return l === 'en' ? companyRaw.en : companyRaw.ja;
};

export const useHomeData = () => {
  const l = useLang();
  return l === 'en' ? homeRaw.en : homeRaw.ja;
};

export const useGiftData = () => {
  const l = useLang();
  return l === 'en' ? giftRaw.en : giftRaw.ja;
};

export const useYokohamaData = () => {
  const l = useLang();
  return l === 'en' ? yokohamaRaw.en : yokohamaRaw.ja;
};

export const useColumnData = () => {
  const l = useLang();
  return l === 'en' ? columnRaw.en : columnRaw.ja;
};
